module.exports = __webpack_public_path__ + "static/continental-logo-f45d0f4e17b0a31d3b28755178073b85.png";